import React from 'react';
import { Container, Row, Col, Button, Image } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import collegeMoon from "../img/AboutMe.png";
import Hello from "../img/helloMyNameIs.png";
import MNZ from "../img/Moonoz.svg";
import HM from "../img/HiddenMouseketeer.png";
import OogieBoogieMoon from "../img/art-Image/shadow-on-the-moon.png";


function Home() {



    return (
        <Container className="No-Left-Right" fluid>
            <Container id="header-Area" className="home-Header" fluid>
                <Container>

                    <Row >
                        <Col className="moonoz-Name" md>
                            <Image src={Hello} className="hello-Img animate__animated animate__fadeInLeft" />
                            <p>(Joel Muñoz)</p>
                            <h3>Front End Developer and Graphic Designer</h3>
                        </Col>
                        <Col md>
                            <Image src={MNZ} className="moonozMain animate__animated animate__fadeInRight" alt="" />
                        </Col>
                    </Row>
                    <div className="home-Header-BG-Shape d-none d-lg-block"></div>
                </Container>
            </Container>

            <Container className="sec-padding" fluid>
                <Row >
                    <Col md>
                        <Image src={collegeMoon} id="College-Moonoz" className="college-Me animate__animated animate__fadeIn" alt="Moonoz College" />
                    </Col>
                    <Col className="sec-Text align-items-center" md>
                        <h2>
                            About Me
                        </h2>
                        <p>
                            First Generation Mexican American College Graduate with a Bachelors degree in Computer Science, Psychology and a Minor in Sociology. After hours I’m a self-taught Digital Graphic Artist giving mind doodles life.
                        </p>

                        <Button variant="danger" href='./aboutMe' size="lg">About Me</Button>
                    </Col>
                </Row>
            </Container>

            <Container className="moon-art-logo img-Sec-Height background-Still" fluid />

            <Container className="sec-padding" fluid>
                <Row>
                    <Col md>
                        <Image src={HM} className="hidden-Mouseketeer img-align" alt="Hidden Mouseketeer" />
                    </Col>
                    <Col className="sec-Text" md>
                        <h2>
                            Tienda
                        </h2>
                        <p>
                            Check out some of my design turned into stickers, pins and other works of art on Big Cartel!
                        </p>
                        <Button variant="danger" href="https://moonozdisenoz.bigcartel.com" target="_blank" rel="noreferrer" size="lg">Shop</Button>
                    </Col>
                </Row>
            </Container>

            <Container className="art-bkgd img-Sec-Height background-Still" fluid />
            {/* art */}
            <Container className="sec-padding" fluid>
                <Row className="">
                    <Col md>
                        <Image src={OogieBoogieMoon} className="oogie-Boogie img-align" alt="Shadow on the moon oogie boogie" />
                    </Col>
                    <Col className="sec-Text margin-auto align-items-center" md>
                        <h2 >
                            Moonoz Diseñoz
                        </h2>
                        <p>
                            Check out some of my art work inspired by my imagination intertwined with cartoons I grew up on!
                        </p>
                        <Button variant="danger" href="/Disenoz" size="lg">Diseñoz</Button>
                    </Col>
                </Row>
            </Container>
        </Container>
    );
}

export default Home;
